/** Superficie pública Sales. Re-exporta desde domain-api, infra-api, app-api + UI directa. */
export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api
export { SaleDetailContent } from './components/SaleDetailContent';
export { SaleDetailMpQrModal } from './components/SaleDetailMpQrModal';
export { VoidSaleConfirmModal } from './components/VoidSaleConfirmModal';
export { SalesScreenHeader } from './components/SalesScreenHeader';
export { SalesTable } from './components/SalesTable';
export { saleDetailStyles } from './components/saleDetail.styles';
export { SaleListRowCard } from './components/SaleListRowCard';
export { SaleDetailModal } from './components/SaleDetailModal';
export { SaleDetailScreen } from './screens/SaleDetailScreen';
export { SalesListScreen } from './screens/SalesListScreen';
